<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Heating Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (airflowSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Actual Airflow:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="airflowSelection.Value"
                (change)="textSelectionChanged(airflowSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(airflowSelection.Name)"/>
              <label class="units-label">CFM</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (edbSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Entering Dry Bulb:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="edbSelection.Value"
                (change)="textSelectionChanged(edbSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(edbSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (eftSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Entering Fluid Temperature:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="eftSelection.Value"
                (change)="textSelectionChanged(eftSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(eftSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadEftSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Entering Fluid Temp:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="loadEftSelection.Value"
                (change)="textSelectionChanged(loadEftSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(loadEftSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (totalCapacitySelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Total Capacity:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="totalCapacitySelection.Value"
                (change)="textSelectionChanged(totalCapacitySelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(totalCapacitySelection.Name)"/>
              <label class="units-label">MBH</label>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
